import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Textarea from '../../Textarea/Textarea'
import Help from '../../Help/Help'
import ValidationMessage from '../../ValidationMessage/ValidationMessage'
import TagAsSelect from '../../TagAsSelect/TagAsSelect'
import AceEditor from 'react-ace'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'

export const Custom = (props: any) => {
  const { onChange, parentInfo, uniqueKey, extensionFieldOption, schema, type, hasNonLocalizablePlan, hasNonLocalizablePlanForBlocksAndGroupMultiple , isNonLocalizable } = props
  console.log(parentInfo, "pasojxhsdjhvcsdck")
  const {
    loadMoreOptions,
    totalCounts,
    isMulti,
    value,
    updateTag,
    openModalCb,
    loadMoreCT,
    isMultiCT,
    openCTModal,
    reference_to,
    plan,
    ...restReference
  } = extensionFieldOption

  const { isMarketplaceEnabled = false } = plan || {}

  const displayNameRef: any = useRef(null)
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  useEffect(() => {
    displayNameRef?.current?.focus()
  }, [displayNameRef])

  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  // const [extension, setExtension] = useState(schema.reference_val)
  const [extension, setExtension] = useState(
    schema.extension_uid ? [{ label: schema.extension_name, value: schema.extension_uid }] : []
  )

  const preSelectedVal = isMultiCT
    ? reference_to.length
      ? reference_to.map((val) => {
        return {
          id: val,
          label: val,
          title: val
        }
      })
      : []
    : reference_to

  const [referenceCT, setReferenceCT] = useState(field_metadata.ref_multiple_content_types ? preSelectedVal : [])

  const configVal = typeof schema.config == 'object' ? JSON.stringify(schema.config) : schema.config

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }

  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onConfigParamChange = (value: any) => {
    schema.config = value
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }

  const handleRefUpdate = (selectedRefs: any) => {
    if (selectedRefs && selectedRefs.contentModal) {
      setExtension([
        {
          label: selectedRefs.contentModal.title,
          value: selectedRefs.uid
        }
      ])
    } else {
      setExtension([])
    }

    schema.extension_uid = selectedRefs.uid
    schema.extension_name = selectedRefs.contentModal && selectedRefs.contentModal.title
    if (selectedRefs.contentModal) {
      if (selectedRefs.contentModal.data_type === 'reference') {
        schema.field_metadata.ref_multiple_content_types = true
        if (!schema.reference_to) {
          schema.reference_to = []
          schema.error_details = {
            ...schema.error_details,
            reference_to: 'Please select a Content type'
          }
          schema.error = true
        }
      } else {
        delete schema.field_metadata.ref_multiple_content_types
        delete schema.reference_to
        setReferenceCT([])
        if (schema.error_details) {
          delete schema.error_details.reference_to
        }
      }
    } else {
      delete schema.field_metadata.ref_multiple_content_types
      delete schema.reference_to
      setReferenceCT([])
      if (schema.error_details) {
        delete schema.error_details.reference_to
      }
    }

    if (schema && !schema.extension_uid) {
      schema.error_details = {
        ...schema.error_details,
        extension_uid: 'Please select an Extension'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        extension_uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }

  const handleCTRefUpdate = (selectedRefs: any) => {
    let newSelectedRef = selectedRefs.length
      ? selectedRefs.map((val) => {
        return {
          id: val,
          label: val,
          title: val
        }
      })
      : []

    setReferenceCT(newSelectedRef)
    schema.reference_to = selectedRefs

    if (schema.reference_to && !schema.reference_to.length) {
      schema.error_details = {
        ...schema.error_details,
        reference_to: 'Please select a Content type'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        reference_to: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }

  if (type === 'basic') {
    if (isMarketplaceEnabled)
      return (
        <div className="FormFields">
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} version='v2' className='FieldLabel__CT' required htmlFor="displayName">
              {props.t('content_type.save_content_type.body.fields.custom.fields.display_name.label')}
            </FieldLabel>
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>

          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} version='v2' className='FieldLabel__CT' required htmlFor="uid">
              {props.t('content_type.save_content_type.body.fields.custom.fields.uid.label')}
            </FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-help-text`} text={props.t('content_type.save_content_type.body.fields.custom.fields.uid.help_text')} />
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={(schema.error && schema.error_details.uid) || error ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId='cs-content-field-custom-basic-extension-label' version='v2' className='FieldLabel__CT' htmlFor="extensionField" required>
              {props.t('content_type.save_content_type.body.fields.custom.fields.select_extension.label')}
            </FieldLabel>
            <TagAsSelect
              testId='cs-content-field-custom-basic-extension'
              version='v2'
              placeholder={props.t(
                'content_type.save_content_type.body.fields.custom.fields.select_extension.placeholder'
              )}
              isMulti={isMulti}
              showEmptyState={true}
              showCount={true}
              showSingleItem={true}
              tags={extension ? extension : []}
              updateTag={handleRefUpdate}
              openModalCb={(callback) => openModalCb(callback)}
              {...restReference}
            />
            {schema.error && schema.error_details.extension_uid ? (
              <ValidationMessage version='v2' testId='cs-content-field-custom-basic-extension-error' className={'error'}>{schema.error_details.extension_uid}</ValidationMessage>
            ) : null}
          </Field>


          {field_metadata.ref_multiple_content_types ? (
            <Field>
              <FieldLabel testId='cs-content-field-custom-basic-referenced-extension-label' version='v2' className='FieldLabel__CT' htmlFor="extensionField">
                {props.t('content_type.save_content_type.body.fields.custom.fields.referenced_ct.label')}
              </FieldLabel>
              <TagAsSelect
                testId='cs-content-field-custom-basic-referenced-extension'
                version='v2'
                placeholder={'Select'}
                showEmptyState={true}
                isMulti={true}
                showCount={true}
                tags={referenceCT.length ? referenceCT : []}
                updateTag={handleCTRefUpdate}
                openModalCb={(callback) => openCTModal(callback)}
                {...restReference}
              />
              {schema.error && schema.error_details.reference_to ? (
                <ValidationMessage testId='cs-content-field-custom-basic-referenced-extension-error' className={'error'}>{schema.error_details.reference_to}</ValidationMessage>
              ) : null}
            </Field>
          ) : null}
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="helpText">
              {props.t('content_type.save_content_type.body.fields.custom.fields.help_text.label')}
            </FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text={props.t('content_type.save_content_type.body.fields.custom.fields.help_text.help_text')} />
            <Textarea
              version='v2'
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="instruction">
              {props.t('content_type.save_content_type.body.fields.custom.fields.instruction.label')}
            </FieldLabel>
            <Help
              type="basic"
              testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`}
              text={props.t('content_type.save_content_type.body.fields.custom.fields.instruction.help_text')}
            />
            <Textarea
              version='v2'
              name={`${uniqueKey}.instruction`}
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
        </div>
      )
    else {
      return (
        <div className="FormFields">
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} version='v2' className='FieldLabel__CT' required htmlFor="displayName">
              Display Name
            </FieldLabel>
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} version='v2' className='FieldLabel__CT' required htmlFor="uid">
              Unique ID
            </FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-help-text`} text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={schema.error && schema.error_details.uid ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.REFERENCE_TAG_AS_SELECT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="extensionField">Select Extension</FieldLabel>
            <TagAsSelect
              version='v2'
              placeholder={'Select'}
              isMulti={isMulti}
              showEmptyState={true}
              showCount={true}
              showSingleItem={true}
              tags={extension ? extension : []}
              updateTag={handleRefUpdate}
              openModalCb={(callback) => openModalCb(callback)}
              {...restReference}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.REFERENCE_TAG_AS_SELECT)}
            />
            {schema.error && schema.error_details.extension_uid ? (
              <ValidationMessage className={'error'}>{schema.error_details.extension_uid}</ValidationMessage>
            ) : null}
          </Field>
          {field_metadata.ref_multiple_content_types ? (
            <Field>
              <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.EXTENTION_TAG_AS_SELECT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="extensionField">Referenced Content Type</FieldLabel>
              <TagAsSelect
                version='v2'
                placeholder={'Select'}
                showEmptyState={true}
                isMulti={true}
                showCount={true}
                tags={referenceCT.length ? referenceCT : []}
                updateTag={handleCTRefUpdate}
                openModalCb={(callback) => openCTModal(callback)}
                {...restReference}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.EXTENTION_TAG_AS_SELECT)}
              />
              {schema.error && schema.error_details.reference_to ? (
                <ValidationMessage className={'error'}>{schema.error_details.reference_to}</ValidationMessage>
              ) : null}
            </Field>
          ) : null}
          <Field >
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="instruction">Instruction Value</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text="Helps you add instructions for this field. The instructional text will appear below the field." />
            <TextInput
              version='v2'
              name={`${uniqueKey}.instruction`}
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DESCRIPTION_INPUT)}-label`} version='v2' className='FieldLabel__CT' htmlFor="helpText">Help Text</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DESCRIPTION_INPUT)}-help-text`} text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
            <Textarea
              version="v2"
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DESCRIPTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DESCRIPTION_INPUT)}
            />
          </Field>

        </div>
      )
    }
  } else if (type === 'advanced') {
    return (
      <>
        <div className="FormFields">
          <Field>
            <FieldLabel testId='cs-content-field-custom-advanced-options-label' version='v2' className='FieldLabel__CT' htmlFor="options">Options</FieldLabel>
            <div className="ToggleWrap">
              <ToggleSwitch
                testId={booleanTestIdFormatter('cs-content-field-custom-advanced-mandatory', schema.mandatory)}
                name={`${uniqueKey}.mandatory`}
                label="Mandatory"
                checked={schema.mandatory}
                onChange={onOptionsChange}
              />
            </div>
            {
              hasNonLocalizablePlan ?
                (hasNonLocalizablePlanForBlocksAndGroupMultiple ?
                  <NonLocalizableDom
                    isFieldPresent={true}
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onOptionsChange={onOptionsChange}
                    dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-content-field-custom-advanced-nl-parent-multiple` : `cs-content-field-custom-advanced-nl`, schema.non_localizable)}
                    dataTestIdForDescription={"cs-ct-field-custom-non-localizable-description"}
                    isNonLocalizable={isNonLocalizable}
                    isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  />
                  : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionsChange}
                      dataTestId={booleanTestIdFormatter("cs-content-field-custom-advanced-nl", schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-custom-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                    />
                    : null
                )
                : null
            }

          </Field>
        </div>
        <div className="FormFields">
          <Field className="AceEditorField">
            <FieldLabel testId='cs-content-field-custom-advanced-configParam-label' version='v2' className='FieldLabel__CT' htmlFor="configParam">Config Parameter</FieldLabel>
            <Help type="basic" testId='cs-content-field-custom-advanced-configParam-help-text' text="The config pamameter that you specify here is applicable only for this instance of the custom field." />
            <AceEditor
              date-test-id='cs-content-field-custom-basic-referenced-configParam'
              style={{ width: "98%" }}
              mode="json"
              theme="github"
              value={configVal}
              onChange={onConfigParamChange}
              name={`${uniqueKey}.config`}
              minLines={8}
              maxLines={20}
              editorProps={{ $blockScrolling: true }}
              setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true
              }}
            />
          </Field>
        </div>
      </>
    )
  }
}

export default React.memo(Custom)
